import { render, staticRenderFns } from "./problem.vue?vue&type=template&id=61c88567&"
import script from "./problem.vue?vue&type=script&lang=js&"
export * from "./problem.vue?vue&type=script&lang=js&"
import style0 from "./problem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61c88567')) {
      api.createRecord('61c88567', component.options)
    } else {
      api.reload('61c88567', component.options)
    }
    module.hot.accept("./problem.vue?vue&type=template&id=61c88567&", function () {
      api.rerender('61c88567', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/msg/problem.vue"
export default component.exports